import React, { useContext, useMemo } from "react";
import styles from "./styles.module.css";
import { FiMenu, FiSearch, FiLogOut, FiMoon, FiSun } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context";

type Props = { title?: string; user?: any };

export default function Header({ title = "Dashboard", user }: Props) {
  const navigate = useNavigate();
  const { toggleDrawer, logout, theme, toggleTheme } = useContext(
    AuthContext,
  ) as any;

  const name = useMemo(() => {
    const full =
      user?.fullname ||
      [user?.firstname, user?.lastname].filter(Boolean).join(" ") ||
      "User";
    return full;
  }, [user]);

  const initials = useMemo(() => {
    const parts = String(name).trim().split(" ").filter(Boolean);
    return (parts[0]?.[0] || "U") + (parts[1]?.[0] || "");
  }, [name]);

  const onLogout = () => {
    logout?.();
    navigate("/");
  };

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button
          type="button"
          className={`${styles.iconBtn} ${styles.mobileOnly}`}
          onClick={toggleDrawer}
          aria-label="Open menu"
          title="Menu"
        >
          <FiMenu />
        </button>

        <div className={styles.titles}>
          <div className={styles.pageTitle}>{title}</div>
          <div className={styles.pageSub}>Overview & insights</div>
        </div>
      </div>

      <div className={styles.center}>
        <div className={styles.search}>
          <FiSearch className={styles.searchIcon} />
          <input placeholder="Search customers, transactions..." />
        </div>
      </div>

      <div className={styles.right}>
        {typeof toggleTheme === "function" && (
          <button
            type="button"
            className={styles.iconBtn}
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title="Toggle theme"
          >
            {theme === "dark" ? <FiSun /> : <FiMoon />}
          </button>
        )}

        <div className={styles.user}>
          <div className={styles.avatar} aria-hidden="true">
            {initials.toUpperCase()}
          </div>
          <div className={styles.userText}>
            <div className={styles.userName}>{name}</div>
            <div className={styles.userRole}>{user?.role || "Admin"}</div>
          </div>
        </div>

        <button
          type="button"
          className={styles.iconBtn}
          onClick={onLogout}
          aria-label="Logout"
          title="Logout"
        >
          <FiLogOut />
        </button>
      </div>
    </header>
  );
}
